/**
 * @generated SignedSource<<e38cc4f3c4e1026994f54c6572071f5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoAcceptActionItemsSetAutoAcceptMutation$variables = {
  acceptAllExisting?: boolean | null;
  enabled: boolean;
};
export type AutoAcceptActionItemsSetAutoAcceptMutation$data = {
  readonly setAutoAcceptForUser: {
    readonly viewer: {
      readonly autoAcceptAiActionItems: boolean | null;
    } | null;
  } | null;
};
export type AutoAcceptActionItemsSetAutoAcceptMutation = {
  response: AutoAcceptActionItemsSetAutoAcceptMutation$data;
  variables: AutoAcceptActionItemsSetAutoAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acceptAllExisting"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v2 = [
  {
    "kind": "Variable",
    "name": "acceptAllExisting",
    "variableName": "acceptAllExisting"
  },
  {
    "kind": "Variable",
    "name": "autoAcceptEnabled",
    "variableName": "enabled"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoAcceptAiActionItems",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoAcceptActionItemsSetAutoAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetAutoAcceptForUser",
        "kind": "LinkedField",
        "name": "setAutoAcceptForUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AutoAcceptActionItemsSetAutoAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetAutoAcceptForUser",
        "kind": "LinkedField",
        "name": "setAutoAcceptForUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7db683daf4e3eda477e94046f52196d",
    "id": null,
    "metadata": {},
    "name": "AutoAcceptActionItemsSetAutoAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation AutoAcceptActionItemsSetAutoAcceptMutation(\n  $enabled: Boolean!\n  $acceptAllExisting: Boolean\n) {\n  setAutoAcceptForUser(autoAcceptEnabled: $enabled, acceptAllExisting: $acceptAllExisting) {\n    viewer {\n      autoAcceptAiActionItems\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebabfcb3823dac563e74c2a00733202d";

export default node;
